import type { Theme } from "../tokens";

/** No hue exists. Hierarchy is weight, size and rule alone. */
export const carbon: Theme = {
  id: "carbon",
  name: "Carbon",
  thesis: "No hue exists. Hierarchy is weight, size and rule alone.",
  scheme: "dark",
  colors: {
    ground: "#000000",
    surface: "#000000",
    raised: "#141414",
    ink: "#FFFFFF",
    dim: "#B0B0B0",
    rule: "#6E6E6E",
    lattice: "#3A3A3A",
    focus: "#FFFFFF",
    inbox: "#FFFFFF",
    feed: "#FFFFFF",
    paperTrail: "#B0B0B0",
    screener: "#FFFFFF",
  },
  type: {
    sans: "'Atkinson Hyperlegible', system-ui, sans-serif",
    mono: "'Atkinson Hyperlegible', system-ui, sans-serif",
    googleFonts: "Atkinson+Hyperlegible:wght@400;700",
    tracking: "0",
  },
  density: {
    row: 56,
    primary: 17,
    secondary: 16,
    meta: 14,
    listWidth: 720,
    rail: 224,
    radius: 0,
    lineHeight: 1.5,
  },
  markers: {
    inbox: "■",
    feed: "▤",
    paperTrail: "▭",
    screener: "▣",
  },
};
